<template>
  <div class="register-container">
    <div class="form-container">
      <div class="form-link">已有账户，<router-link to="/login">马上登录</router-link></div>
      <div class="form-head">注册账号</div>
      <div class="form-main">
        <div class="form-main_">
          <div class="login-inputbox">
            <div class="inputbox account">
              <input type="text" v-model="formData.account" id="mobile" class="input" placeholder="请输入用户名称">
            </div>
          </div>
          <div class="login-inputbox">
            <div class="inputbox password">
              <input type="password" v-model="formData.password" id="password" class="input" placeholder="设置6至20位登陆密码">
            </div>
          </div>
          <div class="login-inputbox">
            <div class="inputbox password">
              <input type="password" v-model="repassword" id="repassword" class="input" placeholder="请再次输入登录密码">
            </div>
          </div>
          <div class="rememberbox">
            <label for="remember">
              <input type="checkbox" v-model="remember" id="remember">勾选同意《<router-link to="/agreement" target="_blank">用户服务协议</router-link>》
            </label>
          </div>
          <div class="login-submit" @click="registerDeal">注册</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHeaderData } from '../../api/getData'
import { validateUserName, validatePassword } from '../../assets/js/validate.js'
export default {
  name: 'register',
  data () {
    return {
      headerInfo: {},
      formData: {
        account: '',
        password: ''
      },
      repassword: '',
      remember: false
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  created () {
    this.getHeaderInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
    },
    async registerDeal () {
      if (this.verification()) {
        let self = this
        let postData = {}
        postData.username = this.formData.account
        postData.password = this.encrypt(this.formData.password)
        let data = await this.$store.dispatch('Register', postData)
        if (data === 'success') {
          self.$router.push({ path: '/success' })
        } else {
          this.message(data)
        }
      }
    },
    verification () {
      if (this.formData.account === '') {
        this.message('请输入用户名称')
        return false
      }
      if (!validateUserName(this.formData.account)) {
        this.message('请输入中文或英文,长度2~10位')
        return false
      }
      if (this.formData.password === '') {
        this.message('请输入登录密码')
        return false
      }
      if (!validatePassword(this.formData.password)) {
        this.message('密码长度6~20位，且同时包含数字、字母')
        return false
      }
      if (this.repassword === '') {
        this.message('请再次输入登录密码')
        return false
      }
      if (this.repassword !== this.formData.password) {
        this.message('两次密码输入不一致')
        return false
      }
      if (!this.remember) {
        this.message('请阅读用户服务协议，并同意')
        return false
      }
      return true
    },
    encrypt (pwd) {
      let pubkey = '-----BEGIN PUBLIC KEY-----'
      pubkey += 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqtcivu827OwO3XQZPpjI'
      pubkey += 'xv3sf3ar0wYkjk6k2XeYJVhyUmqR8r5tpsiLsUhsXwAEA0hjPLkVGHx6ms9A9Tbd'
      pubkey += 'PAji3/WygeCb3SwB3dK85thQlNfGmOS/dtxaUguWU1bZDHN0xldJEVzQFdzpRtce'
      pubkey += 'rTRLyZnYc/SVhUdlhORKDgfu7+ZsH2Xwi8gO3LdqABeukeqqOqnmEtxRIzVWNJsV'
      pubkey += '6TR+2exwxlS5D6B7jEOmBUCvGsNi7xBaQYgXg8aH87CP4pNdueBvCDAIB5oB6zVg'
      pubkey += 'mrVxG909H8pKMZp+4A0AmjXOgTzEhnZ5dB2WHUZT1XvC8CugW/T5U2AX9x0am1+5'
      pubkey += 'aQIDAQAB'
      pubkey += '-----END PUBLIC KEY-----'
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(pubkey)
      let encrypted = encrypt.encrypt(JSON.stringify({ 'encrypt': 'yes', 'password': pwd }))
      return encrypted
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .register-container{
    padding: 90px 0 170px;
    background-image: url("../../assets/images/login-bg.jpg");
    background-repeat: no-repeat;
    background-position: center top;
  }
  .form-container{
    position: relative;
    width: 1300px;
    margin: 0 auto;
    .form-link{
      position: absolute;
      right: 0;
      top: -48px;
      font-size: 20px;
      line-height: 48px;
      color: #333333;
      a{
        color: #4b7bbe;
      }
    }
    .form-head{
      width: 100%;
      height: 90px;
      background-color: #ec6420;
      font-size: 30px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
    }
    .form-main{
      height: 610px;
      background-color: #ffffff;
      .form-main_{
        width: 490px;
        margin: 0 auto;
        padding: 50px 0 0;
        .login-inputbox{
          width: 100%;
          height: 50px;
          border-radius: 25px;
          margin-top: 30px;
          .inputbox {
            width: 100%;
            height: 100%;
            padding-left: 65px;
            border-radius: 25px;
            box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
            background-image: url("../../assets/images/icons.png");
            background-repeat: no-repeat;
            &.account {
              background-position: -322px -37px;
            }
            &.password {
              background-position: -321px -197px;
            }
            .input{
              width: 100%;
              height: 100%;
              padding-right: 30px;
              border-bottom-right-radius: 25px;
              border-top-right-radius: 25px;
              font-size: 18px;
              line-height: 50px;
              color: #999999;
            }
          }
        }
        .rememberbox{
          margin-top: 20px;
          font-size: 14px;
          line-height: 20px;
          color: #999999;
          input[type='checkbox']{
            float: left;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin: 0 8px 0 14px;
            background: url("../../assets/images/icons.png") no-repeat -350px 0;
            appearance: none;
            &:checked{
              background: url("../../assets/images/icons.png") no-repeat -410px 0;
            }
          }
        }
        .login-submit{
          width: 100%;
          height: 50px;
          border-radius: 25px;
          background-color: #ec6420;
          box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
          margin-top: 40px;
          font-size: 24px;
          line-height: 50px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
          transition: all 0.5s ease 0s;
          &:hover{
            background-color: #e5540c;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1320px){
    .form-container{
      width: 100%;
      padding: 0 10px;
      .form-link{
        right: 10px;
      }
    }
  }
  @media screen and (max-width: 1200px){
    .register-container{
      padding: 50px 10px 25px;
    }
    .form-container{
      padding: 0;
      .form-link{
        right: 0;
        top: -50px;
        font-size: 12px;
        line-height: 50px;
      }
      .form-head{
        height: 50px;
        font-size: 16px;
        line-height: 50px;
      }
      .form-main{
        height: 100%;
        .form-main_{
          width: 100%;
          padding: 30px 15px 48px;
          .login-inputbox{
            height: 30px;
            border-radius: 15px;
            margin-top: 15px;
            .inputbox {
              padding-left: 30px;
              border-radius: 15px;
              background-size: 230px auto;
              &.account {
                background-position: -161px -16px;
              }
              &.password {
                background-position: -160px -96px;
              }
              .input{
                padding-right: 15px;
                border-bottom-right-radius: 15px;
                border-top-right-radius: 15px;
                font-size: 12px;
                line-height: 30px;
              }
            }
          }
          .rememberbox{
            margin-top: 18px;
            font-size: 10px;
            line-height: 18px;
            a{
              color: #222222;
            }
            input[type='checkbox']{
              width: 10px;
              height: 10px;
              margin: 4px 6px 0 0;
              background-size: 230px auto;
              background-position: -175px 0;
              &:checked{
                background: url("../../assets/images/icons.png") no-repeat -410px 0;
                background-size: 230px auto;
                background-position: -205px 0;
              }
            }
          }
          .login-submit{
            height: 30px;
            border-radius: 15px;
            margin-top: 26px;
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
    }
  }
</style>
